<div class="d-flex justify-content-between align-items-start px-3 py-2">
  <div>
    <strong>
      <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle; color: #b8860b;">lock</mat-icon>
      System-Determined Checks
    </strong>
    <small class="text-muted">(auto-verified from EdDir / Teach — not asked of applicant)</small>
  </div>
  <mat-icon (click)="closeDialog()" style="cursor: pointer; font-size: 20px; color: #666;">close</mat-icon>
</div>

<div class="px-3 pb-2">
  <span class="border rounded px-2 py-1 bg-white d-inline-block" style="border-color: #ccc !important;">
    <mat-icon style="font-size: 14px; height: 14px; width: 14px; vertical-align: middle; color: #888;">person</mat-icon>
    <strong>{{record.firstName}} {{record.lastName}}</strong>
    <span class="text-muted ms-2">{{record.userId}}</span>
  </span>
</div>

<mat-dialog-content>
  <div style="border: 1px solid #ccc; border-radius: 4px; background: #fff; overflow: hidden;">
    <div *ngFor="let rule of ruleStatuses; let i = index"
         class="d-flex justify-content-between align-items-center px-3 py-2"
         [style.background]="!rule.Passed ? '#fde8e8' : (i % 2 === 0 ? '#fff' : '#f5f5f5')"
         style="border-bottom: 1px solid #e0e0e0;">
      <div class="me-3" style="flex: 1;">
        {{i + 1}}. {{rule.Label}}
      </div>
      <div class="text-nowrap" style="min-width: 140px; text-align: right;">
        <span *ngIf="rule.Passed" style="color: green;">
          &#10004; <strong>{{rule.PassReason || 'Pass'}}</strong>
        </span>
        <span *ngIf="!rule.Passed" style="color: red;">
          &#10008; <strong>Fail</strong>
          <span *ngIf="rule.FailReason"> — {{rule.FailReason}}</span>
        </span>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center px-3 py-2"
         [style.background]="record.manualRejectionFlag ? '#fde8e8' : '#fffde7'">
      <div class="me-3" style="flex: 1;">
        {{ruleStatuses.length + 1}}. Has not been denied by LEA
        <em class="text-muted">(Manually set by LEA)</em>
      </div>
      <div class="text-nowrap" style="min-width: 140px; text-align: right;">
        <span *ngIf="!record.manualRejectionFlag" style="color: green;">&#10004; <strong>Pass</strong></span>
        <span *ngIf="record.manualRejectionFlag" style="color: red;">&#10008; <strong>Denied</strong></span>
      </div>
    </div>
  </div>
</mat-dialog-content>
